import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { SupportMailboxTitle } from "../../../../Constants/Constants";
import { Btn, H6, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";
import { Link } from "react-router-dom";
import { SupportMailboxData } from "../../../../Data/General/Dashboard/Ecommerce";

const SupportMailbox = () => {
  return (
    <Col xxl="4" sm="6" className="box-col-6">
      <Card>
        <DashboardCommonHeader title={SupportMailboxTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="support-box-card">
          {SupportMailboxData.map((item, index) => (
            <div className="d-flex gap-3" key={index}>
              <div className="flex-shrink-0">
                <Image src={dynamicImage(item.image)} alt="user" />
              </div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>
                  <H6>{item.title}</H6>
                </Link>
                <P>{item.content}</P>
              </div>
              <Btn color="transparent" className={`bg-light-${item.color} txt-${item.color} f-w-500`}>
                {item.time}
              </Btn>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default SupportMailbox;
